// Components
import MotivatorsPageLayer from "@Motivators/layouts/MotivatorsPageLayer";
import MotivatorsWrapper from "@Motivators/layouts/MotivatorsWrapper";

// Icons
import SU from "@/assets/icons/motivators/specialUnits/SU.svg";

const SpecialUnitsView = MotivatorsPageLayer({
	WrappedComponent: MotivatorsWrapper,
	headerTitle: "Special Units List",
	headerIcon: SU,
	motivatorType: "specialUnitsSetup",
});

export default SpecialUnitsView;
